import { render, staticRenderFns } from "./historialCambios.vue?vue&type=template&id=5c92e986&scoped=true"
import script from "./historialCambios.vue?vue&type=script&lang=js"
export * from "./historialCambios.vue?vue&type=script&lang=js"
import style0 from "./historialCambios.vue?vue&type=style&index=0&id=5c92e986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92e986",
  null
  
)

export default component.exports